import BaseResponse from "@/model/responses/BaseResponse";

class ProfessionalResponse extends BaseResponse {
  static readBy = {
    data: {
      professionalId: null,
      professionalCustomerId: null,
      professionalOfficialEmail: null,
      professionalLinkedinLink: null,
      professionalFollowers: null,
      professionalRating: null,
      professionalExperienceLength: null,
      professionalExperienceLevel: null,
      professionalIndustry: null,
      professionalCategory: null,
      professionalSubCategory: null,
      professionalEducation: null,
      professionalSummary: null,
      professionalBookingFee: null,
      professionalCreatedAt: null,
      professionalUpdatedAt: null,
      professionalStatus: null,
      customerId: null,
      customerName: null,
      customerDisplayPicture: null,
      customerCoverPhoto: null,
      customerGender: null,
      customerCountry: null,
      customerEmail: null,
      customerDOB: null,
      customerAbout: null,
      customerInterest: null,
      customerTimezone: null,
      customerWalletId: null,
      customerPayOutAccountId: null,
      customerPhoneNumber: null,
      customerCreatedAt: null,
      customerUpdatedAt: null,
      customerStatus: null
    }
  };

  static read = {};
}

export default ProfessionalResponse;
